import type { Theme, SxProps } from '@mui/material/styles';

import { keyframes } from '@mui/material/styles';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

/** 선물 상자의 움직임 — 살짝 튀어 올라 흔들리고 쉬기를 되풀이한다 */
const GIFT_HOP = keyframes`
  0%, 55%, 100% { transform: translateY(0) rotate(0deg); }
  12% { transform: translateY(-3px) rotate(-10deg); }
  24% { transform: translateY(0) rotate(8deg); }
  34% { transform: translateY(-1px) rotate(-4deg); }
  44% { transform: translateY(0) rotate(0deg); }
`;

type Props = {
  /** 아이콘 한 변(px) */
  size?: number;
  sx?: SxProps<Theme>;
};

/**
 * 체험 중 결제 혜택의 표 — 통통 튀는 컬러 선물 상자(`custom:event-gift`). 요금 · 결제 · 만료 화면의 혜택 카드가 쓴다.
 * ⚠️ 움직임 줄이기(`prefers-reduced-motion`)면 흔들리지 않는다.
 */
export function TrialGiftIcon({ size = 18, sx }: Props) {
  return (
    <Iconify
      icon="custom:event-gift"
      width={size}
      sx={[
        {
          flexShrink: 0,
          transformOrigin: '50% 90%',
          animation: `${GIFT_HOP} 2.6s ease-in-out infinite`,
          '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
}
